/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StudentGradeDisciplineViewModel } from "../types/StudentGradeDisciplineViewModel.ts";
import { studentGradeClassViewModelSchema } from "./studentGradeClassViewModelSchema.ts";

export const studentGradeDisciplineViewModelSchema = z.object({
  disciplineId: z.optional(z.number().int().describe("ID da disciplina.")),
  disciplineName: z
    .string()
    .describe("Nome oficial da disciplina no idioma padrão.")
    .nullish(),
  grade: z
    .number()
    .describe(
      "Média ponderada (por peso de prova) de todas as aulas da disciplina, na escala 0-10. Null quando nenhuma nota foi lançada. Opcional.",
    )
    .nullish(),
  frequency: z
    .number()
    .describe(
      "Frequência da disciplina em % (presenças / nº de aulas). Null quando não há aulas registradas. Opcional.",
    )
    .nullish(),
  classes: z
    .array(z.lazy(() => studentGradeClassViewModelSchema))
    .describe(
      "Lista de aulas da disciplina com nota e peso de cada prova, ordenadas pela data de início.",
    )
    .nullish(),
}) as unknown as ToZod<StudentGradeDisciplineViewModel>;
